// Similar to SubscriptionDetailPage but for one-time collections.

import { useParams } from 'react-router-dom';
import { Page } from '@/shared/ui/Page';
import { PageHeader } from '@/shared/ui/PageHeader';
import { useT } from '@/shared/lib/i18n';

export function CollectionDetailPage() {
  const { id } = useParams<{ id: string }>();
  const t = useT();
  void id;

  return (
    <Page>
      <PageHeader title={<span className="font-bold text-[19px]">{t('pages.collection')}</span>} />
      <div className="px-[18px] flex flex-col gap-4">
        {/* TODO */}
      </div>
    </Page>
  );
}
